import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import ShimmerLoader from "../../pages/ShimmerLoader/ShimmerLoader";
import { getTransactionByIdAction } from "../../../store/actions/transaction/TransactionActions";
import moment from "moment-timezone";

const TransactionDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [transaction, setTransaction] = useState({});

  const { loading, error, transactionById } = useSelector((state) => state.transaction);

  useEffect(() => {
    if (!id) {
      navigate("/users");
      return;
    }
    dispatch(getTransactionByIdAction(id, navigate));
  }, [dispatch, id, navigate]);

  useEffect(() => {
    if (transactionById) {
      setTransaction({
        customer_id: transactionById.customer_id || "",
        customer_name: transactionById.customer_name || "",
        customer_phone: transactionById.customer_phone || "",
        gold_quantity: transactionById.gold_quantity || "",
        price_per_gram: transactionById.price_per_gram || "",
        receiver_id: transactionById.receiver_id || "",
        receiver_name: transactionById.receiver_name || "",
        total_amount: transactionById.total_amount || "",
        receiver_phone: transactionById.receiver_phone || "",
        remarks: transactionById.remarks || "",
        status: transactionById.status || "",
        transaction_date: transactionById.transaction_date || "",
        transaction_id: transactionById.transaction_id || "",
        transaction_type: transactionById.transaction_type || "",
      });
    }
  }, [transactionById]);

  const convertToIST = (isoDateTime) => {
    const dateTimeInUTC = moment.utc(isoDateTime);
    const dateTimeInIST = dateTimeInUTC.tz("Asia/Kolkata");
    return dateTimeInIST.format("D MMM YYYY, h:mm:ss A");
  };

  if (loading) {
    return <ShimmerLoader width='95%' height='20%' count={4} />;
  }

  if (error) {
    return (
      <div className='alert alert-danger' role='alert'>
        Error loading transaction data
      </div>
    );
  }

  if (!transactionById) {
    return <div>No transaction data found</div>;
  }
  if (!loading && !error) {
    return (
      <>
        <div className='page-titles'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item'>
              <Link to={"/transactions"}>Transactions</Link>
            </li>
            <li className='breadcrumb-item active'>
              <Link to={"#"}>Transactions Details</Link>
            </li>
          </ol>
        </div>

        {/* <div className='row'>
          <div className='col-lg-12'>
            <div className='card'>
              <div className='card-body'>
                <div className='table-responsive'>
                  <table className='table table-bordered'>
                    <tbody>
                      <tr>
                        <td>Customer Name</td>
                        <td>{transaction.customer_name || "-"}</td>
                      </tr>
                      <tr>
                        <td>Customer Phone</td>
                        <td>{transaction.customer_phone || "-"}</td>
                      </tr>
                      <tr>
                        <td>Receiver Name</td>
                        <td>{transaction.receiver_name || "-"}</td>
                      </tr>
                      <tr>
                        <td>Receiver Phone</td>
                        <td>{transaction.receiver_phone || "-"} </td>
                      </tr>
                      <tr>
                        <td>Gold Quantity</td>
                        <td>{transaction.gold_quantity || "-"} gm</td>
                      </tr>
                      <tr>
                        <td>Price per Gram</td>
                        <td>₹ {transaction.price_per_gram || "-"} </td>
                      </tr>

                      <tr>
                        <td>Total Amount</td>
                        <td> ₹ {transaction.total_amount || "-"} </td>
                      </tr>
                      <tr>
                        <td>Status</td>
                        <td className='text-capitalize'>{transaction.status || "-"}</td>
                      </tr>

                      <tr>
                        <td>Transaction Date</td>
                        <td>{transaction.transaction_date ? convertToIST(transaction.transaction_date) : "-"}</td>
                      </tr>
                      <tr>
                        <td>Transaction ID</td>
                        <td>{transaction.transaction_id || "-"}</td>
                      </tr>
                      <tr>
                        <td>Transaction Type</td>
                        <td className='text-capitalize'>{transaction.transaction_type || "-"}</td>
                      </tr>
                      <tr>
                        <td>Remarks</td>
                        <td>{transaction.remarks || "-"}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className='row'>
          <div className='col-lg-12'>
            <div className='card'>
              <div className='card-body'>
                <div className='table-responsive'>
                  <table className='table table-bordered'>
                    <tbody>
                      <tr>
                        <td>Customer Name</td>
                        <td>{transaction.customer_name || "-"}</td>
                        <td>Customer Phone</td>
                        <td>{transaction.customer_phone || "-"}</td>
                      </tr>
                      <tr>
                        <td>Receiver Name</td>
                        <td>{transaction.receiver_name || "-"}</td>
                        <td>Receiver Phone</td>
                        <td>{transaction.receiver_phone || "-"}</td>
                      </tr>
                      <tr>
                        <td>Gold Quantity</td>
                        <td>{transaction.gold_quantity || "-"} gm</td>
                        <td>Price per Gram</td>
                        <td>₹ {transaction.price_per_gram || "-"}</td>
                      </tr>
                      <tr>
                        <td>Total Amount</td>
                        <td>₹ {transaction.total_amount || "-"}</td>
                        <td>Status</td>
                        <td className='text-capitalize'>{transaction.status || "-"}</td>
                      </tr>
                      <tr>
                        <td>Transaction Date</td>
                        <td>{transaction.transaction_date ? convertToIST(transaction.transaction_date) : "-"}</td>
                        <td>Transaction ID</td>
                        <td>{transaction.transaction_id || "-"}</td>
                      </tr>
                      <tr>
                        <td>Transaction Type</td>
                        <td className='text-capitalize'>{transaction.transaction_type || "-"}</td>
                        <td>Remarks</td>
                        <td>{transaction.remarks || "-"}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default TransactionDetails;
